import React, { useEffect, useState } from 'react';
import useStyle from './carouselQuiz.style';
import { CarouselNav } from '../CarouselNav';
import { QuizCarouselSlide } from '../QuizCarouselSlide';
import { AvailableQuizDef } from 'types/quiz/quiz.def';
import { carouselLoop } from 'helpers/carousel/carsouelLoop';
import { ElevesDashboardProf } from '../../../../types/classe/maClasse';

export interface CarouselQuizProps {
  quizzes: AvailableQuizDef[];
  eleves: ElevesDashboardProf[];
  onClick: (quizID: string) => void;
}

export const CarouselQuiz = ({
  quizzes,
  eleves,
  onClick
}: CarouselQuizProps) => {
  const classes = useStyle();
  const quizzesLength = quizzes.length;
  const [slide, setSlide] = useState(0);
  const [remainingStudents, setRemainingStudents] = useState(0);
  const [averageGrade, setAverageGrade] = useState(0);

  useEffect(() => {
    let etu = 0;
    let moyenne = 0;

    eleves &&
      // eslint-disable-next-line array-callback-return
      eleves.map(eleve => {
        let note = 0;
        const quizEleve = eleve?.quiztonote?.find(
          q => q.quiz && q.quiz.id === quizzes[slide].id
        );
        quizEleve === undefined ? etu++ : (note = quizEleve.note);
        moyenne = moyenne + note;
      });
    setRemainingStudents(etu);
    setAverageGrade(moyenne / eleves.length);
  }, [slide, eleves, quizzes]);

  return (
    <div className={classes.root}>
      <CarouselNav
        previous={() => setSlide(carouselLoop(slide - 1, quizzesLength))}
        next={() => setSlide(carouselLoop(slide + 1, quizzesLength))}
        text={quizzes[slide].name}
        hideArrows={quizzesLength < 2}
      />
      <QuizCarouselSlide
        startDate={new Date(quizzes[slide].debut)}
        endDate={new Date(quizzes[slide].fin)}
        remainingStudents={remainingStudents}
        averageGrade={averageGrade}
        onClick={() => onClick(quizzes[slide].id)}
      />
    </div>
  );
};
